import { useMemo } from 'react';
import { useQueryClient } from '../../lib';
import { getAuthTokensKey, getMembersKey, getPostKey } from '../../utils/keys';
const findMemberInAuthMember = (id, queryClient) => {
    let cachedMember = null;
    const queries = queryClient.getQueriesData({
        queryKey: getAuthTokensKey(),
        active: true,
    });
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        var _a;
        const member = (_a = query[1]) === null || _a === void 0 ? void 0 : _a.member;
        if ((member === null || member === void 0 ? void 0 : member.id) === id) {
            cachedMember = { ...member, ...cachedMember };
        }
    });
    return cachedMember;
};
const findMemberInMembers = (id, queryClient) => {
    let cachedMember = null;
    const queries = queryClient.getQueriesData({
        queryKey: getMembersKey(),
        active: true,
    });
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        var _a;
        const queryData = query[1];
        (_a = queryData === null || queryData === void 0 ? void 0 : queryData.pages) === null || _a === void 0 ? void 0 : _a.forEach(page => {
            var _a;
            (_a = page === null || page === void 0 ? void 0 : page.edges) === null || _a === void 0 ? void 0 : _a.forEach(({ node }) => {
                if ((node === null || node === void 0 ? void 0 : node.id) === id) {
                    cachedMember = { ...node, ...cachedMember };
                }
            });
        });
    });
    return cachedMember;
};
const findMemberInPost = (id, queryClient) => {
    const postKey = getPostKey();
    let cachedMember = null;
    const queries = queryClient.getQueriesData({
        queryKey: postKey,
        active: true,
    });
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        var _a, _b, _c;
        const post = query[1];
        if (((_b = (_a = post === null || post === void 0 ? void 0 : post.owner) === null || _a === void 0 ? void 0 : _a.member) === null || _b === void 0 ? void 0 : _b.id) === id) {
            cachedMember = { ...(_c = post === null || post === void 0 ? void 0 : post.owner) === null || _c === void 0 ? void 0 : _c.member, ...cachedMember };
        }
    });
    return cachedMember;
};
const getCachedMember = (id, queryClient) => {
    const member = findMemberInAuthMember(id, queryClient) ||
        findMemberInMembers(id, queryClient) ||
        findMemberInPost(id, queryClient);
    return member && Object.keys(member).length ? member : null;
};
export const useCachedMember = (id) => {
    const queryClient = useQueryClient();
    return useMemo(() => getCachedMember(id, queryClient), [id, queryClient]);
};
//# sourceMappingURL=useCachedMember.js.map